import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "strategic-partners" }
const _hoisted_2 = { class: "main container" }
const _hoisted_3 = { class: "about-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "about-title-1" }, " Hanjin Introduction ", -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box-about-desc" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "about-desc" }, [
      /*#__PURE__*/_createElementVNode("p", null, "한진택배는 테라사이클과 국내 파트너십을 통해 우리 지구의 더 나은 미래를 위해 함께합니다."),
      /*#__PURE__*/_createElementVNode("p", null, "테라사이클코리아와 함께하는 모든 재활용 캠페인 및 프로그램의 수거 및 배송은 국내 최초 물류 선도 기업 한진에서 함께합니다."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("p", null, "또한, 한진 택배는 환경 보호를 위해 테이프를 사용하지 않는 친환경 포장 패키지를 활용해 테라사이클이 함께하는 캠페인의 수거품을 모으는 수거 박스를 제작 지원 함으로서 국내 친환경 자원 순환 프로그램에 함께합니다."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("p", null, "테라사이클의 택배 서비스는 ‘물류로 세상을 연결하는’ 글로벌 종합 물류 기업 한진택배와 함께 합니다.")
    ]),
    /*#__PURE__*/_createElementVNode("a", {
      class: "jump-btn",
      href: "#"
    }, " 더 알아보기 ")
  ])
], -1)
const _hoisted_7 = { class: "col-12 col-lg-6" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "box-partners" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "title-box d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "about-title-1" }, " Our Partners ")
], -1)
const _hoisted_11 = { class: "logo-box" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["src"]

import Images from '../images';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const items = [
    { imgUrl: Images.About.logo1, link: '#' },
    { imgUrl: Images.About.logo2, link: '#' },
    { imgUrl: Images.About.logo3, link: '#' },
    { imgUrl: Images.About.logo4, link: '#' },
    { imgUrl: Images.About.logo5, link: '#' },
    { imgUrl: Images.About.logo6, link: '#' },
    { imgUrl: Images.About.logo7, link: '#' },
    { imgUrl: Images.About.logo8, link: '#' },
    { imgUrl: Images.About.logo9, link: '#' },
    { imgUrl: Images.About.logo10, link: '#' },
  ];

return (_ctx: any,_cache: any) => {
  const _component_AppBanner = _resolveComponent("AppBanner")!
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_AppCarouselWithController = _resolveComponent("AppCarouselWithController")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBanner, {
      title: "TerraCycle parthers",
      image: _unref(Images).About.bannerHanjin
    }, null, 8, ["image"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppBreadcurmb, { routes: [{name: 'Home', to: {name: 'home'}}, {name: 'Strategic Partners', to: {name: 'about_2'}}] }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              src: _unref(Images).About.bannerHanjinIntro,
              class: "banner"
            }, null, 8, _hoisted_8)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_AppCarouselWithController, {
              "chunk-size": 4,
              "mobile-chunk-size": 2,
              "show-indicator": false,
              interval: 3000,
              items: items
            }, {
              default: _withCtx((item) => [
                _createElementVNode("a", {
                  href: item.link
                }, [
                  _createElementVNode("img", {
                    src: item.imgUrl,
                    class: "img"
                  }, null, 8, _hoisted_13)
                ], 8, _hoisted_12)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})